import React, { useEffect, useState } from 'react'
import Container from '@mui/material/Container'
import { useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import {
  Tabs,
  Tab,
} from '@mui/material'
import PropTypes from 'prop-types'
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import './flights.css'
import OneWay from './OneWay'
import RoundTrip from './RoundTrip'
import MultiCity from './MultiCity'
import Banner from './Banner'
import CalendareFare from './CalendareFare'
import Topdeals from '../../top-deals/Topdeals'
import FlightIcon from '@mui/icons-material/Flight';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import moment from 'moment'
import MobileAppBanner from '../../mobile-app-banner/MobileAppBanner'
import GroupfaresLink from '../../groupefare-link/GroupfaresLink'
import SpecialOffer from '../../special-offer/SpecialOffer'
import { authPost, getAuth } from '../../../utility/apiConfig';
import { API_BASE_URL } from '../../../utility/apiConstants';

const Flight = () => {
  const user = useSelector(state => state.user)
  const [checked, setChecked] = useState(true);
  const [tripError, setTripError] = useState({
    fromError: '',
    toError: '',
    depatureError: '',
    returnError: ''
  })
  const [trip, setTrip] = useState({
    from: '',
    from_loc_id: '',
    to: '',
    to_loc_id: '',
    depature: moment().add(1, 'days').format("DD-MM-yy")
  })
  // const [tripType, setTripType] = useState('oneway')
  const [oneWay, setOneWay] = useState({
    trip_type: 'oneway',
    from: '',
    from_loc_id: '',
    to: '',
    to_loc_id: '',
    depature: moment().add(1, 'days').format("DD-MM-yy"),
    adult: 1,
    child: 0,
    infant: 0,
    nonStop: false,
    studentFare: false,
    search_flight: 'search',
    v_class: 'Economy',
    carrier: [],
    specialFare: false,
    rating: [],
    fareType: [],
  })
  const [fromAirport, setFromAirport] = useState([])
  const [fromValue, setFromValue] = useState(null)
  const [toAirport, setToAirport] = useState([])
  const [toValue, setToValue] = useState(null)
  const [isOpenDepart, setIsOpenDepart] = useState('')
  const [depDate, setDepDate] = useState(moment().add(1, 'days'))
  const [retDate, setRetDate] = useState(null)
  const [returnDate, setReturnDate] = useState('')
  const [isOpenReturn, setIsOpenReturn] = useState('')
  const [fromCountry, setFromCountry] = useState(null)
  const [toCountry, setToCountry] = useState(null)
  const [showSparkles, setShowSparkles] = useState(false)
  const [show, setShow] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [winningMessage, setWinningMessage] = useState(null);
  let number = 720

  const handleClose = () => { setShow(false); setMessage(null); setWinningMessage(null); setShowSparkles(false); number=720 };
  const handleShow = () => setShow(true);

  //  useEffect(() =>{
  //   setTimeout(()=>{
  //     setShow(true)
  //   }, 2000)
  //  }, [])


  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`nav-tabpanel-${index}`}
        aria-labelledby={`nav-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  }

  function flightTabProps(index) {
    return {
      id: `nav-tab-${index}`,
      'aria-controls': `nav-tabpanel-${index}`
    }
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper
    }
  }))
  const classes = useStyles()

  const [flightSearchType, setFlightSearchType] = useState(0)

  const handleFlightSearchType = (event, type) => {
    setFlightSearchType(type)
  }

  const segments = [
    "INR 25",
    "INR 50",
    "INR 100",
    "INR 250",
    "INR 500",
    "INR 1000",
  ];
  const segColors = ["#EE4040", "#F0CF50", "#dc3545", "#34A24F", "#815CD1", "#3DA5E0"];
  const onFinished = (winner) => {
    setShowSparkles(true)
    onWinPrizes();
  };

  const onWinPrizes = () => {
    let dataToSend = {
      date: new Date(),
      amount: 50,
      userId: user.userDetails.user_id
    }
    //console.log("dataToSend", dataToSend)
    try {
      authPost(API_BASE_URL + 'management/add_spin_win_bonus', dataToSend)
        .then((response) => {
          if (response.data.status) {
            setWinningMessage(response.data.message)
            setSpinLoading(false)
          }
        })
        .catch((error) => {
          setMessage("Something went wrong.\n Please try again after sometime.")
          setSpinLoading(false)
        })
    } catch (error) {
      setSpinLoading(false)
    }
  };
  const handleSpin = () => {
    setSpinLoading(true);
    handleShow();
    try {
      getAuth(API_BASE_URL + 'management/check_eligibility_spin_win')
        .then((response) => {
          if (!response.data.status) {
            setMessage(response.data.message)
          }
          setSpinLoading(false)
        })
    } catch (error) {
      setSpinLoading(false)
    }
  }

  const onSpin = () => {
    let container = document.getElementById("container2");
    container.style.transform = "rotate(" + number + "deg)";
    number = number * 2;
    setTimeout(function () { setShowSparkles(true); onWinPrizes(); }, 3470);
    return
  }

  return (
    <>
      <Banner />
      <Container className="search-box">
        <Grid container spacing={0}>
          <Grid
            item
            lg={12}
            md={12}
            xs={12}
            spacing={0}
          >
            <Box pt={0}>
              <Tabs
                border={1}
                variant="fullWidth"
                indicatorColor="primary"
                centered
                textColor="primary"
                color="primary"
                value={flightSearchType}
                onChange={handleFlightSearchType}
                aria-label="nav tabs example"
                spacing={0}
                className="bg-white searchtab-main"
              >
                <Tab
                  className="tabTilte"
                  variant="contained"
                  label="Oneway"
                  icon={<FlightIcon />}
                  {...flightTabProps(0)}
                  style={{
                    borderTopLeftRadius: 0
                  }}
                />
                <Tab
                  className="tabTilte"
                  label="Round Trip"
                  icon={<ConnectingAirportsIcon className='roundair-icon' />}
                  {...flightTabProps(1)}
                  style={{
                    borderLeft: '1px solid #ccc',
                    borderRight: '1px solid #ccc',
                    borderBottom: '1px solid #ccc'
                  }}
                />
                {/* <Tab
                  className="tabTilte"
                  label="Multi city"
                  icon={<AirlineStopsIcon />}
                  {...flightTabProps(2)}
                  style={{
                    borderBottom: '1px solid #ccc',
                    borderRight: '1px solid #ccc'
                  }}
                /> */}
                {/* <Link to='/flight/specialfare'> */}
                <Tab
                  className="tabTilte"
                  label="Special Fares"
                  icon={<LocalOfferOutlinedIcon className='dealIcon' />}
                  style={{ borderBottom: '1px solid #ccc' }}
                  onClick={() => { window.location.href = "/flight/specialfare" }}
                  {...flightTabProps(3)}

                />
                {/* </Link> */}
                {/* <Tab
                  className="tabTilte"
                  label="Calendar Fare"
                  icon={<CalendarMonthIcon />}
                  {...flightTabProps(4)}
                  style={{ borderBottom: '1px solid #ccc' }}
                /> */}
              </Tabs>


              <TabPanel className="tabsPanelbdr bg-white" value={flightSearchType} index={0}>
                <OneWay
                  tripError={tripError}
                  setTripError={setTripError}
                  trip={trip}
                  setTrip={setTrip}
                  fromAirport={fromAirport}
                  setFromAirport={setFromAirport}
                  fromValue={fromValue}
                  setFromValue={setFromValue}
                  toAirport={toAirport}
                  setToAirport={setToAirport}
                  toValue={toValue}
                  setToValue={setToValue}
                  isOpenDepart={isOpenDepart}
                  setIsOpenDepart={setIsOpenDepart}
                  depDate={depDate}
                  setDepDate={setDepDate}
                  fromCountry={fromCountry}
                  setFromCountry={setFromCountry}
                  toCountry={toCountry}
                  setToCountry={setToCountry} />
              </TabPanel>

              <TabPanel className="tabsPanelbdr bg-white" value={flightSearchType} index={1}>
                <RoundTrip
                  tripError={tripError}
                  setTripError={setTripError}
                  trip={trip}
                  setTrip={setTrip}
                  fromAirport={fromAirport}
                  setFromAirport={setFromAirport}
                  fromValue={fromValue}
                  setFromValue={setFromValue}
                  toAirport={toAirport}
                  setToAirport={setToAirport}
                  toValue={toValue}
                  setToValue={setToValue}
                  isOpenDepart={isOpenDepart}
                  setIsOpenDepart={setIsOpenDepart}
                  depDate={depDate}
                  setDepDate={setDepDate}
                  retDate={retDate}
                  setRetDate={setRetDate}
                  isOpenReturn={isOpenReturn}
                  setIsOpenReturn={setIsOpenReturn}
                  returnDate={returnDate}
                  setReturnDate={setReturnDate}
                  fromCountry={fromCountry}
                  setFromCountry={setFromCountry}
                  toCountry={toCountry}
                  setToCountry={setToCountry}
                />
              </TabPanel>

              <TabPanel className="tabsPanelbdr bg-white tabsPanelContainer" value={flightSearchType} index={2} >
                <MultiCity />
              </TabPanel>
              <TabPanel className="tabsPanelbdr bg-white tabsPanelContainer" value={flightSearchType} index={3} >
                {/* <MultiCity /> */}
              </TabPanel>

              <TabPanel className="tabsPanelbdr bg-white" value={flightSearchType} index={4}>
                <CalendareFare />
              </TabPanel>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <GroupfaresLink />
      <SpecialOffer />
      <Topdeals />
      {/* <HotelTopdeals /> */}
      <MobileAppBanner />
    
    </>
  )
}

export default Flight
